import { Box, Paper, Typography, Alert } from "@mui/material";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { reportsApi, type StockOnHandRow } from "@/api/endpoints";
import { errorMessage } from "@/api/client";

export function StockOnHandPage() {
  const query = useQuery({
    queryKey: ["stock-on-hand"],
    queryFn: () => reportsApi.stockOnHand(),
  });

  const columns: GridColDef<StockOnHandRow>[] = [
    { field: "itemName", headerName: "Item", flex: 1.2, minWidth: 220,
      renderCell: (p) => (
        <span><b>{p.row.itemName}</b> <span style={{ color: "#888" }}>{p.row.sku}</span></span>
      )
    },
    { field: "batchNo", headerName: "Batch", width: 140 },
    { field: "expiryDate", headerName: "Expiry", width: 110,
      valueFormatter: (v) => v ? new Date(v as string).toLocaleDateString() : "—" },
    { field: "warehouseName", headerName: "Warehouse", flex: 1, minWidth: 160 },
    { field: "onHand", headerName: "On hand", width: 110, type: "number" },
    { field: "reserved", headerName: "Reserved", width: 110, type: "number" },
    { field: "available", headerName: "Available", width: 120, type: "number" },
  ];

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>Stock on hand</Typography>
      <Paper sx={{ p: 2 }}>
        {query.isError && <Alert severity="error" sx={{ mb: 2 }}>{errorMessage(query.error)}</Alert>}
        <Box sx={{ height: 600 }}>
          <DataGrid
            rows={query.data ?? []}
            columns={columns}
            loading={query.isLoading}
            getRowId={(row) => `${row.batchId}|${row.warehouseId}`}
            disableRowSelectionOnClick
            initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
            pageSizeOptions={[25, 50, 100]}
          />
        </Box>
      </Paper>
    </Box>
  );
}
